<template>
  <div class="my-info-browsinghistory">
    <div class="f-nav">
      <div :class="['nav', changeType == 'l' ? 'active-nav' : '']">
        <div class="nav-block" @click="change_type('l')">
          <div class="nav-block-arrow">
            <div>浏览历史</div>
            <div class="arrow-bottom"></div>
          </div>
          <div
            :class="[
              'nav',
              changeType == 'l' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
      <div
        :class="['nav', changeType == 's' ? 'active-nav' : '']"
        @click="change_type('s')"
      >
        <div class="nav-block">
          <div>收藏房源</div>
          <div
            :class="[
              'nav',
              changeType == 's' ? 'change-line-active' : 'change-line',
            ]"
          ></div>
        </div>
      </div>
    </div>

    <div ref="homeCon">
      <div class="wrapper" v-show="changeType == 'l'">
        <house-item
          v-for="(house, index) in list"
          :key="index"
          :house="house"
          type="2"
          @handleHosue="handleHosue"
        ></house-item>
      </div>
    </div>
    <div
      class="browse-menu"
      v-show="changeType == 'l' && show_selectedType"
      @click="closedChage()"
    >
      <div class="change-type">
        <div
          :class="['tag', liu_selected == 'ershoufan' ? 'active-tag' : '']"
          @click="selectType('ershoufan')"
        >
          <div>二手房</div>
          <div style="display: none" class="show-active-tag">
            <img
              class="selected-icon"
              src="../../images/icon/selected.png"
              alt=""
            />
          </div>
        </div>
        <div
          :class="['tag', liu_selected == 'zufan' ? 'active-tag' : '']"
          @click="selectType('zufan')"
        >
          <div>租房</div>
          <div style="display: none" class="show-active-tag">
            <img
              class="selected-icon"
              src="../../images/icon/selected.png"
              alt=""
            />
          </div>
        </div>
        <div
          :class="['tag', liu_selected == 'xinfan' ? 'active-tag' : '']"
          @click="selectType('xinfan')"
        >
          <div>新房</div>
          <div style="display: none" class="show-active-tag">
            <img
              class="selected-icon"
              src="../../images/icon/selected.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import actions from "../../common/actions.js";
import util from "../../common/util.js";
import houseItem from "../../component/houseItem_my.vue";
export default {
  components: { houseItem },
  data() {
    return {
      list: [],
      changeType: "l",
      liu_selected: "ershoufan",
      show_selectedType: false,

      pageTotle: 1,
      pageSize: 10, // 一页item数
      pageIndex: 1, // index 此处是第几条数据的index(具体情况具体分析)
      windowHeight: window.innerHeight, // 窗口高度
      isIn: false, // 是否在区域内
      isChange: false, // 区域是否发生改变
    };
  },
  created() {
    this.$store.commit("changeTitle", "浏览历史");
    util.hideLoading();
  },
  updated() {},
  computed: {
    isGetPage() {
      return this.isIn && this.isChange; // 是否能够请求下一页的变量
    },
  },
  destroyed() {
    window.removeEventListener("scroll", () => {});
  },
  watch: {
    isGetPage(newVal) {
      // 如果新的值是true
      if (newVal) {
        // 请求接口，具体情况具体分析
        if (this.pageTotle >= this.pageIndex) {
          this.pageIndex++;
          this.getBrowseList(this.liu_selected);
        } else {
          console.log("到底了");
        }
      }
    },
  },

  mounted() {
    this.getBrowseList(this.liu_selected);
    this.handleScroll();
  },
  methods: {
    handleHosue(type, house) {
      if (type == "detail") {
        this.$router.push({
          name: "detail",
          params: { id: house.id, type: this.type },
          query: this.$route.query,
        });
      }
    },
    change_type(data) {
      this.changeType = data;
      this.show_selectedType = true;
       this.pageTotle=1,
      this.pageIndex=1,
      this.list = []
    },
    selectType(type) {
      this.liu_selected = type;
      this.getBrowseList();
    },
    closedChage() {
      this.show_selectedType = false;
      this.getBrowseList();
    },
    getBrowseList() {
      let data = {
        page_size: this.pageSize,
        page_number: this.pageIndex,
        Param: "gzhid",
        Type: this.liu_selected,
      };
      actions.get_browse_list(data).then((res) => {
        console.log(res);
        if (res.is_success == "yes") {
          this.list = this.list.concat(res.content);
          this.pageTotle = res.all_page;
        }
      });
    },
    // 滚动加载分页
    handleScroll: util.throttle(function () {
      window.addEventListener("scroll", () => {
        // 算出剩余未显示高度
        let height = this.$refs.homeCon.offsetHeight - window.pageYOffset - this.windowHeight;
        // 指定区域高度，如果剩余高度小于指定高度，说明进入了指定的区域
        if (height < 0) {
          // 在指定区域内，确定是否是从上面的区域进来，只有在两个变量都是false的时候，他才能够为true
          this.isChange = !this.isIn && !this.isChange;
          this.isIn = true; // 在指定区域内
        } else {
          this.isIn = false; // 在区域外
          this.isChange = false; // 回归初始状态
        }
      });
    }, 2000),
  },
};
</script>

<style scoped lang="scss">
.my-info-browsinghistory {
  min-block-size: 100vh;
  background: #ffffff;
  .f-nav {
    height: 0.8rem;
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    height: 1rem;
    .nav {
      width: 50%;
      font-size: 0.3rem;
      text-align: center;
      font-weight: 600;
      display: flex;
      align-items: center;
      .change-line {
        display: inline-block;
        width: 0.3rem;
        height: 0.06rem;
      }
      .change-line-active {
        display: inline-block;
        width: 0.3rem;
        height: 0.06rem;
        background-image: linear-gradient(to right, #f5e2b8, #edbd59);
        border-radius: 0.06rem;
      }
      .nav-block {
        margin: 0 auto;
      }
    }
    .active-nav {
      color: #ecb94c;
    }
  }

  .search {
    position: relative;
    display: flex;
    align-items: center;
    height: 0.6rem;
    margin: 0.2rem 0.23rem;
    background-color: #e8e8e9;
    padding: 0 0 0 0.18rem;
    .search-input {
      flex: 1;
      background-color: #e8e8e9;
      padding-left: 0.2rem;
    }
    .search-btn {
      color: #fff;
      height: 0.6rem;
      line-height: 0.6rem;
      background-color: #ff725c;
      border-color: #ff725c;
      text-align: center;
      border-radius: 0.05rem;
      font-size: 0.2rem;
      padding: 0 0.3rem;
    }
  }
  .filter {
    position: relative;
    display: flex;
    height: 0.9rem;
    border-top: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;
    background-color: #fff;
    .filter-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #999;
      font-size: 0.24rem;
    }
    .filter-icon {
      margin-left: 0.1rem;
    }
  }

  .wrapper {
    border-bottom: 1px solid #f2f2f2;
    padding-left: 0.4rem;
    background-color: #fff;
  }
  .wrapper-null {
    font-size: 0.32rem;
    color: #999;
    line-height: 5em;
    text-align: center;
  }
  .loadmore-tip {
    font-size: 0.24rem;
    color: #999;
    line-height: 2em;
    text-align: center;
    background-color: #f5f5f5;
  }
  .browse-menu {
    position: fixed;
    top: 1rem;
    height: 100vh;
    width: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    .change-type {
      padding: 0.2rem 0.4rem;
      background: #ffffff;
      z-index: 9999;
      .tag {
        font-size: 0.3rem;
        height: 0.7rem;
        background: #ffffff;
        line-height: 0.6rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .active-tag {
        color: #ecb94c;
        .show-active-tag {
          display: block !important;
        }
      }
    }
  }
  .arrow-bottom {
    width: 0;
    height: 0;
    border-right: 0.1rem solid transparent;
    border-left: 0.1rem solid transparent;
    border-top: 0.1rem solid #ecb94c;
    display: block;
  }
  .nav-block-arrow {
    position: relative;
  }
  .arrow-bottom {
    position: absolute;
    top: 0.11rem;
    right: -0.3rem;
  }
  .selected-icon {
    width: 0.4rem;
  }
}
</style>

